document.addEventListener('DOMContentLoaded', () => {

    /* ONE change listener for the whole page */
    document.addEventListener('change', (e) => {
      if (!e.target.matches('.collection-variant-radio')) return;
  
      const form = e.target.closest('form.collection_form');
      if (!form) return;
  
      const variants    = JSON.parse(form.dataset.variants);
      const optionOrder = JSON.parse(form.dataset.options);     
  
      const selectedMap = {};
      form.querySelectorAll('.collection-variant-radio:checked')
          .forEach(radio => (selectedMap[radio.name] = radio.value));
  
      const selectedArr = optionOrder.map(name => selectedMap[name] || null);
  
      const selectedVariant = variants.find(v =>
        v.options.every((opt, idx) => opt === selectedArr[idx])
      );
  
      if (!selectedVariant) return;     // not all options chosen yet
  
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = selectedVariant.id;
  
      const atcBtn   = form.querySelector('.collection-atc');
      const btnLabel = atcBtn?.querySelector('.btn-label');
  
      const soldOut = (!selectedVariant.available) ||
                      (selectedVariant.inventory_quantity <= 0 &&
                       selectedVariant.inventory_policy === 'deny');
  
      if (soldOut) {
        atcBtn?.setAttribute('disabled', 'disabled');
        if (btnLabel) btnLabel.textContent = 'Sold out';
      } else {
        atcBtn?.removeAttribute('disabled');
        if (btnLabel) btnLabel.textContent = 'Add to cart';
      }

      console.log('Selected variant:', selectedVariant);

      const selPrice        = selectedVariant.price;
      const selComparePrice = selectedVariant.compare_at_price;
      
      console.log('Card price:', selPrice);
      console.log('Card compare price:', selComparePrice);
      
      if (selComparePrice && selComparePrice > selPrice) {
        const card = form.closest('.grid__item');
        if (!card) return;
      
        const compareEl = card.querySelector('.compare-at-price');
        if (compareEl) compareEl.textContent = '$' + formatPrice(selComparePrice);
      
        const priceEl = card.querySelector('.price-item.adjustborder .money');
        if (priceEl) priceEl.textContent = formatPrice(selPrice);
      }
      

      function formatPrice(money){
        if ((money / 100) % 1 === 0) {
            money = ((money)/100).toFixed(0);
            return money;
          }else{
            money = money / 100;
            return money;
        }
      }

    });
});
  
// AJAX "Add to cart" for any .collection_form 
document.addEventListener('DOMContentLoaded', () => {

    /* One listener for ALL collection-page product forms */
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches('form.collection_form')) return;   // ignore other submits
      e.preventDefault();
  
      /* ----- quick UI feedback (optional) ----- */
      const atcBtn   = form.querySelector('.collection-atc');
      const btnLabel = atcBtn?.querySelector('.btn-label');
      atcBtn?.classList.add('loading');
      if (btnLabel) btnLabel.textContent = 'Adding…';
  
      /* ----- build request body from THIS form ----- */
      const formData = new FormData(form);
  
      /* ----- 1. /cart/add.js ----- */
      fetch('/cart/add.js', {
        method: 'POST',
        body:   formData,
        headers:{ 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(r => {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      /* ----- 2. fetch updated cart sections ----- */
      .then(() =>
        fetch('/?sections=cart-drawer,cart-icon-bubble', {
          headers:{ 'X-Requested-With': 'XMLHttpRequest' }
        })
      )
      .then(r => {
        if (!r.ok) throw new Error('Failed to load cart sections');
        return r.json();
      })
      .then(sections => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer?.renderContents) {
          console.warn('cart-drawer element or renderContents() missing');
          return;
        }
  
        cartDrawer.renderContents({
          id: Date.now(),   // dummy ID Dawn expects
          sections
        });
  
        /* give Dawn’s template a tick to mount */
        setTimeout(() => {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
          cartDrawer.querySelector('.drawer__inner')?.classList.remove('is-empty');
          cartDrawer.querySelector('.drawer__inner-empty')?.style.setProperty('display','none');
  
          cartDrawer.classList.add('active');
          document.body.classList.add('overflow-hidden');
        }, 50);
      })
      .catch(err => {
        console.error('Error handling cart drawer update:', err);
        alert('Sorry – couldn’t add that item. Please try again.');
      })
      .finally(() => {
        atcBtn?.classList.remove('loading');
        if (btnLabel) btnLabel.textContent = 'Add to cart';
      });
    });
  
  });
  // End of AJAX

  // Toggle class for hide and show product options
  document.querySelectorAll('li.grid__item .choose-options').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      const parent = this.closest('.col-choose-options');
      if (parent) {
        parent.classList.toggle('show');
      }
    });
  });


  document.querySelectorAll('li.grid__item svg.col-product-close-icon').forEach(el => {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Close icon clicked');
      const parent = this.closest('.col-choose-options');
      if (parent) {
        parent.classList.remove('show');
      }
      
    })
  })
  
  
  // End of toggle class
  